import { type FC, type HTMLAttributes, type ReactNode } from 'react'

import './index.scss'

export interface Heading1Props extends HTMLAttributes<HTMLHeadingElement> {
  children: ReactNode
  className?: string
}

export const Heading1: FC<Heading1Props> = ({ children, className = '', ...rest }) => (
  <h1 className={`heading-1 ${className}`} {...rest}>
    {children}
  </h1>
)
